module.exports = __webpack_public_path__ + "img/icono-go.662fcf90.svg";